import * as Monitaro from '@/infrastructure/network/Monitaro/schema/models'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'

/**
 * Googleカレンダーの一覧の取得
 *
 * 連携したアカウントのカレンダー一覧を取得する
 */
export class FetchCalendarGoogle implements APIRequest<Monitaro.FetchCalendarGoogleResponse> {
  response: Monitaro.FetchCalendarGoogleResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: Monitaro.Query
  constructor(query?: Monitaro.Query) {
    this.params = query
    this.path = `/calendars/google`
  }
}

/**
 * カレンダー連携を解除する
 *
 * 連携したGoogleカレンダーの連携を解除する
 */
export class DeleteCalendarGoogle implements APIRequest<Monitaro.DeleteCalendarGoogleResponse> {
  response: Monitaro.DeleteCalendarGoogleResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.DELETE
  constructor() {
    this.path = `/calendars/google`
  }
}

/**
 * Googleカレンダーの連携中のデータの数を返す
 *
 * 連携と削除の進捗を取得する
 */
export class RelationCalendarGoogle implements APIRequest<Monitaro.RelationCalendarGoogleResponse> {
  response: Monitaro.RelationCalendarGoogleResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  constructor(id: string) {
    this.path = `/calendars/google/relation/${id}`
  }
}

/**
 * 選択されたカレンダーをIDを保存する
 *
 * 連携したGoogleカレンダーのどのカレンダーに連携するかを保存する
 */
export class PutCalendarGoogle implements APIRequest<Monitaro.PutCalendarGoogleResponse> {
  response: Monitaro.PutCalendarGoogleResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.PUT
  params: Monitaro.GoogleCalendarRequest
  constructor(id: string, params: Monitaro.GoogleCalendarRequest) {
    this.params = params
    this.path = `/calendars/google/${id}`
  }
}

/**
 * 連携したカレンダーデータを削除する
 *
 * 連携したGoogleカレンダーのイベントデータを削除する
 */
export class CleaningCalendarGoogle implements APIRequest<Monitaro.CleaningCalendarGoogleResponse> {
  response: Monitaro.CleaningCalendarGoogleResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.DELETE
  constructor(id: string) {
    this.path = `/calendars/google/${id}`
  }
}
